import React from "react"
import {useQuery, useSubscription} from "@apollo/client"
import mediaGetDetails from "graphql/Media/Media/query/mediaGetDetails"
import {FileDetails} from "components/backoffice/Storage/File/Details/FileDetails"

import './style.scss'
import mediaUpdate from "graphql/Media/Media/subscription/mediaUpdate"
import {MediaUpgrade} from "../Upgrade/MediaUpgrade"

type MediaDetailsProps = {
  mediaId: string,
}

export const MediaDetails = (props: MediaDetailsProps) => {

  useSubscription(mediaUpdate, {
    skip: !props?.mediaId,
    variables: {
      id: props?.mediaId,
    }
  })

  const {data} = useQuery(mediaGetDetails, {
    skip: !props?.mediaId,
    variables: {
      id: props?.mediaId
    }
  })

  const media = data?.media
  const versionList = media?.Version

  return <div className="media-details-container">
    <h1>Media</h1>
    <h2>Versions</h2>
    {versionList?.map((version: any) => {
      return <div key={`version_${version?.id}`}>
        <h3>Version {version.role || version.language} / {version.codec || "legacy"} / {version.height ? `${version.height}p` : "résolution inconnue"}{version.isHdr ? " HDR" : ""}</h3>
        {version.audioLanguages?.length > 0 && <div>Audio : {version.audioLanguages.join(", ")}</div>}
        <FileDetails File={version?.File} />
      </div>
    })}
    <MediaUpgrade mediaId={props.mediaId} />
    <h2>Subtitles</h2>
    <div>TODO</div>
  </div>
}
